export const getManifestUrl = (url) => `https://d3otrhxcw2ss5z.cloudfront.net/${url}/manifest.json`;
